<template>
  <v-container grid-list-lg>
    <v-layout column>
      <v-layout align-center="align-center" justify-center row>
        <div class="text-center">
          <h1 class="h1-header">Thank You!</h1>
          <p>Your order has been successfully placed</p>
        </div>
      </v-layout>
      <v-layout row wrap>
        <div class="text-left">
          <h2 class="headline">Order Information</h2>
          <div>
            Your account id is <span class="font-weight-regular">{{ signUp.data.cspid }}</span>
          </div>
          <div>Please refer to this number if you need further assistance for this order</div>
          <div>You can review your order in customer portal</div>
          <div class="mt-2">
            <h6 class="subheading green--text">We are currently setting up your database.</h6>
            <h6 class="subheading green--text">
              You will receive a call from CellSmart POS specialist within 30 minutes to assist you
              with the software installation.
            </h6>
          </div>
        </div>
      </v-layout>
    </v-layout>
    <component class="mt-4" :is="upsaleDeal"> </component>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Repair from "../components/UpSale/Repair";
import BillPayment from "../components/UpSale/BillPayment";
import TimeClock from "../components/UpSale/TimeClock";
import Hardware from "../components/UpSale/Hardware";
import Promotion from "../components/UpSale/Promotion";
import Review from "../components/UpSale/Review";
import Welcome from "../components/UpSale/Welcome";
export default {
  data() {
    return {
      e1: 1
    };
  },
  components: {
    Repair,
    BillPayment,
    Hardware,
    Welcome,
    Review,
    Promotion,
    TimeClock
  },
  computed: {
    ...mapGetters("location", ["deals", "signUp"]),
    upsaleDeal() {
      console.log("test", this.deals);
      if (this.deals.length === 0) {
        return "Welcome";
      } else {
        return this.deals[0];
      }
    }
  },
  created() {
    this.loadDeals();
    if (!this.signUp) {
      this.$router.push({ name: "location-dashboard" });
    }
  },
  methods: {
    ...mapActions("location", ["loadDeals"])
  }
};
</script>

<style scoped>
.hidden {
  display: block;
}
</style>
